import * as types from '../mutation-types';
import KanbanAPI from '../../api/kanban';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getKanbanData: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
  isFetching: _state => _state.uiFlags.isFetching,
};

export const actions = {
  get: async ({ commit }, { attributeKey = 'funil' } = {}) => {
    commit(types.SET_KANBAN_UI_FLAG, { isFetching: true });
    try {
      const response = await KanbanAPI.get({ attributeKey });
      commit(types.SET_KANBAN_DATA, response.data);
      return response;
    } finally {
      commit(types.SET_KANBAN_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_KANBAN_DATA](stateData, data) {
    stateData.records = data;
  },
  [types.SET_KANBAN_UI_FLAG](stateData, uiFlags) {
    stateData.uiFlags = { ...stateData.uiFlags, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
